import drawnBulletsPagination from "../helpers/drawnBulletsPagination";

class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.activeVideos = [];

    this.addEventListener("click", (e) => {
      const thumbnail = e.target.closest("[data-thumbnail]");

      if (thumbnail) {
        this._selectMedia(thumbnail.dataset.mediaId);
      }

      const media = e.target.closest("[data-media]");

      if (media && this._enableClickZoom) {
        const { mediaId } = media.dataset;
        const zoomGallery = this._zoomMarkup.content.children[0];
        zoomGallery.dataset.preselectMedia = mediaId;

        const html = zoomGallery.outerHTML;
        this.dispatchEvent(
          new CustomEvent("markup-modal:open", {
            bubbles: true,
            detail: { html, target: "zoom-modal" },
          })
        );
      }
    });

    if ("preselectMedia" in this.dataset) {
      this._selectMedia(this.dataset.preselectMedia);
    }

    this.handleResize = () => this._checkCarousel();

    window.loadSwiper.then(({ Swiper, Pagination }) => {
      this.Swiper = Swiper;
      this.Pagination = Pagination;

      window.addEventListener("resize", this.handleResize);
      this._checkCarousel();
    });
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
  }

  _checkCarousel() {
    if (this._isMobile) {
      this._initCarousel();
    } else {
      this._destroyCarousel();
    }
  }

  _initCarousel() {
    if (this.gallerySwiper) return;

    this._toggleSwiperClasses(true);

    const swiperParams = {
      modules: [this.Pagination],
      slidesPerView: "auto",
      spaceBetween: 15,
      speed: 400,
      zoom: {
        maxRatio: 3
      },
      pagination: drawnBulletsPagination,
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
      },
    };

    this.gallerySwiper = new this.Swiper(
      this.querySelector(`.${this._prefix}__media-container`),
      swiperParams
    );
    this.gallerySwiper.on("slideChange", () => {
      const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
        slide.classList.contains("swiper-slide-visible")
      );
      this._selectVideo(visibleSlides);
    });
  }

  _destroyCarousel() {
    if (!this.gallerySwiper) return;

    this.gallerySwiper.destroy(true, true);
    this.gallerySwiper = null;
    this._toggleSwiperClasses(false);
  }

  _toggleSwiperClasses(add) {
    this.querySelectorAll("[data-swiper-class]").forEach((el) => {
      el.classList.toggle(el.dataset.swiperClass, add);
    });
  }

  _selectMedia(id) {
    this._media.forEach((media) => {
      media.classList.toggle(
        `${this._prefix}__media-wrapper--active`,
        media.dataset.mediaId === id
      );
    });

    this._thumbnails.forEach((thumbnail) => {
      thumbnail.classList.toggle(
        `${this._prefix}__thumbnail-button--selected`,
        thumbnail.dataset.mediaId === id
      );
    });

    const activeMedia = this.querySelectorAll(
      `[data-media][data-media-id="${id}"]`
    );

    this._selectVideo(activeMedia);
  }

  _selectVideo(els) {
    this.activeVideos.forEach((video) => video.pause());

    this.activeVideos = [];

    els.forEach((el) => {
      const video = el.querySelector("video");

      if (video) {
        this.activeVideos.push(video);
        video.play();
      }
    });
  }

  get _media() {
    return this._mediaEls || this.querySelectorAll("[data-media]");
  }

  get _thumbnails() {
    return this._thumbnailEls || this.querySelectorAll("[data-thumbnail]");
  }

  get _zoomMarkup() {
    return this.querySelector("[data-zoom-markup]");
  }

  get _enableClickZoom() {
    return !this._isMobile && this.hasAttribute("enable-click-zoom");
  }

  get _prefix() {
    return this.dataset.classPrefix;
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 1024px)").matches;
  }
}

if (!customElements.get("media-gallery")) {
  customElements.define("media-gallery", MediaGallery);
}
